import toast from "react-hot-toast";
import useRead from "../../hooks/useRead";

const useGetSalaryTemplates = () => {
  const { list, paramsObject, setGetListParams } = useRead({
    url: "template-salary-structure/list",
    method: "GET",
    onError: (error) => {
      toast.error("Error fetching salary templates: " + error.message);
    },
  });
  const isTemplateListLoading = list.isLoading;
  const templatesList = list.data?.salary_structure_data || [];
  const pagination = list.data?.pagination || {};

  const handlePageClick = (page) => {
    setGetListParams({ ...paramsObject, pageNo: page.selected });
  };

  return { templatesList, pagination, isTemplateListLoading, handlePageClick };
};

export default useGetSalaryTemplates;
